export default {
    resetPassword: 'Changer le mot de passe',
    title: 'Un message contenant les instructions pour changer le mot de passe sera envoyé à l’adresse email associée à ce compte.',
    btnText: 'Envoyer',
}